module.exports = __webpack_public_path__ + "img/near_cyl125_axis0.c0fa1c66.jpg";